/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Maintenance {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description List all saved vendors for the organization
   *
   * @tags Maintenance
   * @name GetAllVendors
   * @summary Get All Vendors
   * @request GET:/api/maintenance/vendors
   * @secure
   */
  getAllVendors = (params = {}) =>
    this.http.request({
      path: `/api/maintenance/vendors`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Save a new vendor contact
   *
   * @tags Maintenance
   * @name CreateVendor
   * @summary Create Vendor
   * @request POST:/api/maintenance/vendors
   * @secure
   */
  createVendor = (data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/vendors`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve unified list of past contracted vendors and bookmarked marketplace vendors.
   *
   * @tags Maintenance
   * @name GetUnifiedVendors
   * @summary Get Unified Vendors
   * @request GET:/api/maintenance/vendors/unified
   * @secure
   */
  getUnifiedVendors = async (query, params = {}) => {
    if (this.http?.instance?.get) {
      const res = await this.http.instance.get(`/api/maintenance/vendors/unified`, {
        params: query,
        ...params,
      });
      return res?.data ?? res;
    }
    return this.http.request({
      path: `/api/maintenance/vendors/unified`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  };
  /**
   * @description Update a saved vendor contact or link to marketplace profile
   *
   * @tags Maintenance
   * @name UpdateVendor
   * @summary Update Vendor
   * @request PUT:/api/maintenance/vendors/{vendor_id}
   * @secure
   */
  updateVendor = (vendorId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/vendors/${vendorId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update a saved vendor contact or link to marketplace profile
   *
   * @tags Maintenance
   * @name UpdateVendor2
   * @summary Update Vendor
   * @request PATCH:/api/maintenance/vendors/{vendor_id}
   * @originalName updateVendor
   * @duplicate
   * @secure
   */
  updateVendor2 = (vendorId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/vendors/${vendorId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a saved vendor
   *
   * @tags Maintenance
   * @name DeleteVendor
   * @summary Delete Vendor
   * @request DELETE:/api/maintenance/vendors/{vendor_id}
   * @secure
   */
  deleteVendor = (vendorId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/vendors/${vendorId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Create maintenance project
   *
   * @tags Maintenance
   * @name CreateProject
   * @summary Create Project
   * @request POST:/api/maintenance/projects
   * @secure
   */
  createProject = (data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List maintenance projects
   *
   * @tags Maintenance
   * @name ListProjects
   * @summary List Projects
   * @request GET:/api/maintenance/projects
   * @secure
   */
  listProjects = (query, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List planning milestones for a maintenance project.
   *
   * @tags Maintenance
   * @name ListMilestones
   * @summary List Milestones
   * @request GET:/api/maintenance/projects/{project_id}/milestones
   * @secure
   */
  listMilestones = (projectId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/milestones`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get maintenance project by ID
   *
   * @tags Maintenance
   * @name GetProject
   * @summary Get Project
   * @request GET:/api/maintenance/projects/{project_id}
   * @secure
   */
  getProject = (projectId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update maintenance project
   *
   * @tags Maintenance
   * @name UpdateProject
   * @summary Update Project
   * @request PATCH:/api/maintenance/projects/{project_id}
   * @secure
   */
  updateProject = (projectId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Activate maintenance project
   *
   * @tags Maintenance
   * @name ActivateProject
   * @summary Activate Project
   * @request POST:/api/maintenance/projects/{project_id}/activate
   * @secure
   */
  activateProject = (projectId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/activate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Complete maintenance project
   *
   * @tags Maintenance
   * @name CompleteProject
   * @summary Complete Project
   * @request POST:/api/maintenance/projects/{project_id}/complete
   * @secure
   */
  completeProject = (projectId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/complete`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Cancel maintenance project
   *
   * @tags Maintenance
   * @name CancelProject
   * @summary Cancel Project
   * @request POST:/api/maintenance/projects/{project_id}/cancel
   * @secure
   */
  cancelProject = (projectId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/cancel`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Hold maintenance project
   *
   * @tags Maintenance
   * @name HoldProject
   * @summary Hold Project
   * @request POST:/api/maintenance/projects/{project_id}/hold
   * @secure
   */
  holdProject = (projectId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/hold`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List sections for a maintenance project (includes the default Global section).
   *
   * @tags Maintenance
   * @name ListSections
   * @summary List Sections
   * @request GET:/api/maintenance/projects/{project_id}/sections
   * @secure
   */
  listSections = (projectId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/sections`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a project section
   *
   * @tags Maintenance
   * @name CreateSection
   * @summary Create Section
   * @request POST:/api/maintenance/projects/{project_id}/sections
   * @secure
   */
  createSection = (projectId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/sections`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update a project section
   *
   * @tags Maintenance
   * @name UpdateSection
   * @summary Update Section
   * @request PATCH:/api/maintenance/projects/{project_id}/sections/{section_id}
   * @secure
   */
  updateSection = (projectId, sectionId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/sections/${sectionId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a project section
   *
   * @tags Maintenance
   * @name DeleteSection
   * @summary Delete Section
   * @request DELETE:/api/maintenance/projects/{project_id}/sections/{section_id}
   * @secure
   */
  deleteSection = (projectId, sectionId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/sections/${sectionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Reorder project sections
   *
   * @tags Maintenance
   * @name ReorderSections
   * @summary Reorder Sections
   * @request PUT:/api/maintenance/projects/{project_id}/sections/reorder
   * @secure
   */
  reorderSections = (projectId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/sections/reorder`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Extract structured maintenance line items from voice dictations or notes.
   *
   * @tags Maintenance
   * @name ExtractScoping
   * @summary Extract Scoping
   * @request POST:/api/maintenance/projects/{project_id}/sections/{section_id}/extract-scoping
   * @secure
   */
  extractScoping = (projectId, sectionId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/sections/${sectionId}/extract-scoping`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create a line item
   *
   * @tags Maintenance
   * @name CreateLineItem
   * @summary Create Line Item
   * @request POST:/api/maintenance/projects/{project_id}/line-items
   * @secure
   */
  createLineItem = (projectId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/line-items`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List line items for a project
   *
   * @tags Maintenance
   * @name ListLineItems
   * @summary List Line Items
   * @request GET:/api/maintenance/projects/{project_id}/line-items
   * @secure
   */
  listLineItems = (projectId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/line-items`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a line item
   *
   * @tags Maintenance
   * @name GetLineItem
   * @summary Get Line Item
   * @request GET:/api/maintenance/line-items/{line_item_id}
   * @secure
   */
  getLineItem = (lineItemId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/line-items/${lineItemId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a line item
   *
   * @tags Maintenance
   * @name UpdateLineItem
   * @summary Update Line Item
   * @request PATCH:/api/maintenance/line-items/{line_item_id}
   * @secure
   */
  updateLineItem = (lineItemId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/line-items/${lineItemId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a line item
   *
   * @tags Maintenance
   * @name DeleteLineItem
   * @summary Delete Line Item
   * @request DELETE:/api/maintenance/line-items/{line_item_id}
   * @secure
   */
  deleteLineItem = (lineItemId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/line-items/${lineItemId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Start a line item
   *
   * @tags Maintenance
   * @name StartLineItem
   * @summary Start Line Item
   * @request POST:/api/maintenance/line-items/{line_item_id}/start
   * @secure
   */
  startLineItem = (lineItemId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/line-items/${lineItemId}/start`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Submit a line item for approval
   *
   * @tags Maintenance
   * @name SubmitLineItem
   * @summary Submit Line Item
   * @request POST:/api/maintenance/line-items/{line_item_id}/submit
   * @secure
   */
  submitLineItem = (lineItemId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/line-items/${lineItemId}/submit`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Cancel a line item
   *
   * @tags Maintenance
   * @name CancelLineItem
   * @summary Cancel Line Item
   * @request POST:/api/maintenance/line-items/{line_item_id}/cancel
   * @secure
   */
  cancelLineItem = (lineItemId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/line-items/${lineItemId}/cancel`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create an evaluation question on a section.
   *
   * @tags Maintenance
   * @name CreateEvaluationQuestion
   * @summary Create Evaluation Question
   * @request POST:/api/maintenance/projects/{project_id}/sections/{section_id}/evaluation-questions
   * @secure
   */
  createEvaluationQuestion = (projectId, sectionId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/sections/${sectionId}/evaluation-questions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List evaluation questions for a section.
   *
   * @tags Maintenance
   * @name ListEvaluationQuestions
   * @summary List Evaluation Questions
   * @request GET:/api/maintenance/projects/{project_id}/sections/{section_id}/evaluation-questions
   * @secure
   */
  listEvaluationQuestions = (projectId, sectionId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/sections/${sectionId}/evaluation-questions`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a single evaluation question.
   *
   * @tags Maintenance
   * @name GetEvaluationQuestion
   * @summary Get Evaluation Question
   * @request GET:/api/maintenance/evaluation-questions/{evaluation_question_id}
   * @secure
   */
  getEvaluationQuestion = (evaluationQuestionId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/evaluation-questions/${evaluationQuestionId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an evaluation question (e.g. record an answer).
   *
   * @tags Maintenance
   * @name UpdateEvaluationQuestion
   * @summary Update Evaluation Question
   * @request PATCH:/api/maintenance/evaluation-questions/{evaluation_question_id}
   * @secure
   */
  updateEvaluationQuestion = (evaluationQuestionId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/evaluation-questions/${evaluationQuestionId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an evaluation question.
   *
   * @tags Maintenance
   * @name DeleteEvaluationQuestion
   * @summary Delete Evaluation Question
   * @request DELETE:/api/maintenance/evaluation-questions/{evaluation_question_id}
   * @secure
   */
  deleteEvaluationQuestion = (evaluationQuestionId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/evaluation-questions/${evaluationQuestionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Request a vendor quote for a maintenance request.
   *
   * @tags Maintenance
   * @name CreateRequestQuote
   * @summary Create Request Quote
   * @request POST:/api/maintenance/requests/{request_id}/quotes
   * @secure
   */
  createRequestQuote = (requestId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/quotes`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List quotes for a maintenance request.
   *
   * @tags Maintenance
   * @name ListRequestQuotes
   * @summary List Request Quotes
   * @request GET:/api/maintenance/requests/{request_id}/quotes
   * @secure
   */
  listRequestQuotes = (requestId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/quotes`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Generate a normalized side-by-side comparison matrix for all vendor quotes on a maintenance request.
   *
   * @tags Maintenance
   * @name CompareRequestQuotes
   * @summary Compare Request Quotes
   * @request GET:/api/maintenance/requests/{request_id}/quotes/compare
   * @secure
   */
  compareRequestQuotes = (requestId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/quotes/compare`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Request a vendor quote
   *
   * @tags Maintenance
   * @name CreateQuote
   * @summary Create Quote
   * @request POST:/api/maintenance/projects/{project_id}/quotes
   * @secure
   */
  createQuote = (projectId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/quotes`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List quotes for a project
   *
   * @tags Maintenance
   * @name ListQuotes
   * @summary List Quotes
   * @request GET:/api/maintenance/projects/{project_id}/quotes
   * @secure
   */
  listQuotes = (projectId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/projects/${projectId}/quotes`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get quote by ID
   *
   * @tags Maintenance
   * @name GetQuote
   * @summary Get Quote
   * @request GET:/api/maintenance/quotes/{quote_id}
   * @secure
   */
  getQuote = (quoteId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/quotes/${quoteId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Submit a quote
   *
   * @tags Maintenance
   * @name SubmitQuote
   * @summary Submit Quote
   * @request POST:/api/maintenance/quotes/{quote_id}/submit
   * @secure
   */
  submitQuote = (quoteId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/quotes/${quoteId}/submit`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Accept a quote (Management Approval Only).
   *
   * @tags Maintenance
   * @name AcceptQuote
   * @summary Accept Quote
   * @request POST:/api/maintenance/quotes/{quote_id}/accept
   * @secure
   */
  acceptQuote = (quoteId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/quotes/${quoteId}/accept`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Reject a quote
   *
   * @tags Maintenance
   * @name RejectQuote
   * @summary Reject Quote
   * @request POST:/api/maintenance/quotes/{quote_id}/reject
   * @secure
   */
  rejectQuote = (quoteId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/quotes/${quoteId}/reject`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Request clarification on a submitted quote, transitioning it to NEEDS_CLARIFICATION.
   *
   * @tags Maintenance
   * @name ClarifyQuote
   * @summary Clarify Quote
   * @request POST:/api/maintenance/quotes/{quote_id}/clarify
   * @secure
   */
  clarifyQuote = (quoteId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/quotes/${quoteId}/clarify`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all maintenance statements for current organization.
   *
   * @tags Maintenance
   * @name ListAllStatements
   * @summary List All Statements
   * @request GET:/api/maintenance/statements
   * @secure
   */
  listAllStatements = (params = {}) =>
    this.http.request({
      path: `/api/maintenance/statements`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a billing statement directly with request_id in body.
   *
   * @tags Maintenance
   * @name CreateStandaloneStatement
   * @summary Create Standalone Statement
   * @request POST:/api/maintenance/statements
   * @secure
   */
  createStandaloneStatement = (data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/statements`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Compile unbilled maintenance line items into unified statements.
   *
   * @tags Maintenance
   * @name CompileStatements
   * @summary Compile Statements
   * @request POST:/api/maintenance/statements/compile
   * @secure
   */
  compileStatements = (data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/statements/compile`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Compile unbilled line items for a specific maintenance template/request.
   *
   * @tags Maintenance
   * @name CompileRequestStatements
   * @summary Compile Request Statements
   * @request POST:/api/maintenance/requests/{request_id}/statements/compile
   * @secure
   */
  compileRequestStatements = (requestId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/statements/compile`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create a billing statement for a maintenance request.
   *
   * @tags Maintenance
   * @name CreateStatement
   * @summary Create Statement
   * @request POST:/api/maintenance/requests/{request_id}/statements
   * @secure
   */
  createStatement = (requestId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/statements`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List statements for a maintenance request.
   *
   * @tags Maintenance
   * @name ListStatements
   * @summary List Statements
   * @request GET:/api/maintenance/requests/{request_id}/statements
   * @secure
   */
  listStatements = (requestId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/statements`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a maintenance statement by ID.
   *
   * @tags Maintenance
   * @name GetStatement
   * @summary Get Statement
   * @request GET:/api/maintenance/statements/{statement_id}
   * @secure
   */
  getStatement = (statementId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/statements/${statementId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Download compiled PDF for a maintenance statement with Chilean Ley 21.133 tax withholding.
   *
   * @tags Maintenance
   * @name GetStatementPdf
   * @summary Get Statement Pdf
   * @request GET:/api/maintenance/statements/{statement_id}/pdf
   * @secure
   */
  getStatementPdf = (statementId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/statements/${statementId}/pdf`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Submit a draft statement to the responsible party.
   *
   * @tags Maintenance
   * @name SubmitStatement
   * @summary Submit Statement
   * @request POST:/api/maintenance/statements/{statement_id}/submit
   * @secure
   */
  submitStatement = (statementId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/statements/${statementId}/submit`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Approve a submitted statement.
   *
   * @tags Maintenance
   * @name ApproveStatement
   * @summary Approve Statement
   * @request POST:/api/maintenance/statements/{statement_id}/approve
   * @secure
   */
  approveStatement = (statementId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/statements/${statementId}/approve`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Dispute a submitted statement.
   *
   * @tags Maintenance
   * @name DisputeStatement
   * @summary Dispute Statement
   * @request POST:/api/maintenance/statements/{statement_id}/dispute
   * @secure
   */
  disputeStatement = (statementId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/statements/${statementId}/dispute`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List line items attached to a statement.
   *
   * @tags Maintenance
   * @name ListStatementLineItems
   * @summary List Statement Line Items
   * @request GET:/api/maintenance/statements/{statement_id}/line-items
   * @secure
   */
  listStatementLineItems = (statementId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/statements/${statementId}/line-items`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add a new line item to a draft statement.
   *
   * @tags Maintenance
   * @name AddStatementLineItem
   * @summary Add Statement Line Item
   * @request POST:/api/maintenance/statements/{statement_id}/line-items
   * @secure
   */
  addStatementLineItem = (statementId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/statements/${statementId}/line-items`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update a line item on a draft statement.
   *
   * @tags Maintenance
   * @name UpdateStatementLineItem
   * @summary Update Statement Line Item
   * @request PATCH:/api/maintenance/statements/{statement_id}/line-items/{line_item_id}
   * @secure
   */
  updateStatementLineItem = (statementId, lineItemId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/statements/${statementId}/line-items/${lineItemId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete or unlink a line item from a draft statement.
   *
   * @tags Maintenance
   * @name DeleteStatementLineItem
   * @summary Delete Statement Line Item
   * @request DELETE:/api/maintenance/statements/{statement_id}/line-items/{line_item_id}
   * @secure
   */
  deleteStatementLineItem = (statementId, lineItemId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/statements/${statementId}/line-items/${lineItemId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Preview tax calculation (Líquido vs Bruto vs Retención vs IVA) for a given amount, RUT, and document type.
   *
   * @tags Maintenance
   * @name CalculateTaxPreview
   * @summary Calculate Tax Preview
   * @request POST:/api/maintenance/tax/calculate
   * @secure
   */
  calculateTaxPreview = (data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/tax/calculate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Calculate or update statement tax breakdown and compliance status.
   *
   * @tags Maintenance
   * @name CalculateStatementTaxCompliance
   * @summary Calculate Statement Tax Compliance
   * @request POST:/api/maintenance/statements/{statement_id}/tax-compliance
   * @secure
   */
  calculateStatementTaxCompliance = (statementId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/statements/${statementId}/tax-compliance`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Upload and attach tax voucher (Boleta/Factura) to maintenance statement.
   *
   * @tags Maintenance
   * @name UploadStatementTaxDocument
   * @summary Upload Statement Tax Document
   * @request POST:/api/maintenance/statements/{statement_id}/tax-document
   * @secure
   */
  uploadStatementTaxDocument = (statementId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/statements/${statementId}/tax-document`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create a maintenance request.
   *
   * @tags Maintenance
   * @name CreateRequest
   * @summary Create Request
   * @request POST:/api/maintenance/requests
   * @secure
   */
  createRequest = (data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List maintenance requests.
   *
   * @tags Maintenance
   * @name ListRequests
   * @summary List Requests
   * @request GET:/api/maintenance/requests
   * @secure
   */
  listRequests = (query, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List maintenance requests (paginated).
   *
   * @tags Maintenance
   * @name ListRequestsPaged
   * @summary List Requests Paged
   * @request GET:/api/maintenance/requests/paged
   * @secure
   */
  listRequestsPaged = (query, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/paged`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List open maintenance requests.
   *
   * @tags Maintenance
   * @name ListOpenRequests
   * @summary List Open Requests
   * @request GET:/api/maintenance/requests/open
   * @secure
   */
  listOpenRequests = (params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/open`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List unassigned co-managed maintenance requests.
   *
   * @tags Maintenance
   * @name ListUnassignedRequests
   * @summary List Unassigned Requests
   * @request GET:/api/maintenance/requests/unassigned
   * @secure
   */
  listUnassignedRequests = (params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/unassigned`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get maintenance request by ID.
   *
   * @tags Maintenance
   * @name GetRequest
   * @summary Get Request
   * @request GET:/api/maintenance/requests/{request_id}
   * @secure
   */
  getRequest = (requestId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Assign vendor to maintenance request.
   *
   * @tags Maintenance
   * @name AssignVendor
   * @summary Assign Vendor
   * @request PUT:/api/maintenance/requests/{request_id}/assign
   * @secure
   */
  assignVendor = (requestId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/assign`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update maintenance request status.
   *
   * @tags Maintenance
   * @name UpdateStatus
   * @summary Update Status
   * @request PUT:/api/maintenance/requests/{request_id}/status
   * @secure
   */
  updateStatus = (requestId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/status`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Close a completed maintenance request.
   *
   * @tags Maintenance
   * @name CloseRequest
   * @summary Close Request
   * @request PUT:/api/maintenance/requests/{request_id}/close
   * @secure
   */
  closeRequest = (requestId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/close`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Attach an uploaded asset as a maintenance request photo.
   *
   * @tags Maintenance
   * @name AddRequestPhoto
   * @summary Add Request Photo
   * @request POST:/api/maintenance/requests/{request_id}/photos
   * @secure
   */
  addRequestPhoto = (requestId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/photos`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List child occurrences of a recurring maintenance template.
   *
   * @tags Maintenance
   * @name ListOccurrences
   * @summary List Occurrences
   * @request GET:/api/maintenance/requests/{request_id}/occurrences
   * @secure
   */
  listOccurrences = (requestId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/occurrences`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create an ad-hoc occurrence for a recurring maintenance template.
   *
   * @tags Maintenance
   * @name CreateAdHocOccurrence
   * @summary Create Ad Hoc Occurrence
   * @request POST:/api/maintenance/requests/{request_id}/occurrences
   * @secure
   */
  createAdHocOccurrence = (requestId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/occurrences`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Generate upcoming occurrences for a recurring maintenance template.
   *
   * @tags Maintenance
   * @name GenerateTemplateOccurrences
   * @summary Generate Template Occurrences
   * @request POST:/api/maintenance/requests/{request_id}/occurrences/generate
   * @secure
   */
  generateTemplateOccurrences = (requestId, query, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/occurrences/generate`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Generate upcoming occurrences across all active recurring maintenance templates.
   *
   * @tags Maintenance
   * @name GenerateAllOccurrences
   * @summary Generate All Occurrences
   * @request POST:/api/maintenance/requests/occurrences/generate
   * @secure
   */
  generateAllOccurrences = (query, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/occurrences/generate`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Pause a recurring maintenance template.
   *
   * @tags Maintenance
   * @name PauseTemplate
   * @summary Pause Template
   * @request POST:/api/maintenance/requests/{request_id}/pause
   * @secure
   */
  pauseTemplate = (requestId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/pause`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Activate a recurring maintenance template.
   *
   * @tags Maintenance
   * @name ActivateTemplate
   * @summary Activate Template
   * @request POST:/api/maintenance/requests/{request_id}/activate
   * @secure
   */
  activateTemplate = (requestId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/activate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Cancel a recurring maintenance template.
   *
   * @tags Maintenance
   * @name CancelTemplate
   * @summary Cancel Template
   * @request POST:/api/maintenance/requests/{request_id}/cancel
   * @secure
   */
  cancelTemplate = (requestId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/cancel`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Escalate/promote a maintenance request into a capital project.
   *
   * @tags Maintenance
   * @name EscalateToProject
   * @summary Escalate To Project
   * @request POST:/api/maintenance/requests/{request_id}/escalate-to-project
   * @secure
   */
  escalateToProject = (requestId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/escalate-to-project`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List unassigned co-managed maintenance requests for coordinator dashboard.
   *
   * @tags Maintenance
   * @name ListCoordinatorUnassignedRequests
   * @summary List Coordinator Unassigned Requests
   * @request GET:/api/maintenance/coordinator/unassigned
   * @secure
   */
  listCoordinatorUnassignedRequests = (params = {}) =>
    this.http.request({
      path: `/api/maintenance/coordinator/unassigned`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a work order / submit scope pre-approval.
   *
   * @tags Maintenance
   * @name CreateWorkOrder
   * @summary Create Work Order
   * @request POST:/api/maintenance/work-orders
   * @secure
   */
  createWorkOrder = (data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List work orders with optional filtering.
   *
   * @tags Maintenance
   * @name ListWorkOrders
   * @summary List Work Orders
   * @request GET:/api/maintenance/work-orders
   * @secure
   */
  listWorkOrders = (query, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve work order by ID.
   *
   * @tags Maintenance
   * @name GetWorkOrder
   * @summary Get Work Order
   * @request GET:/api/maintenance/work-orders/{work_order_id}
   * @secure
   */
  getWorkOrder = (workOrderId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a work order.
   *
   * @tags Maintenance
   * @name UpdateWorkOrder
   * @summary Update Work Order
   * @request PUT:/api/maintenance/work-orders/{work_order_id}
   * @secure
   */
  updateWorkOrder = (workOrderId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update a work order.
   *
   * @tags Maintenance
   * @name UpdateWorkOrder2
   * @summary Update Work Order
   * @request PATCH:/api/maintenance/work-orders/{work_order_id}
   * @originalName updateWorkOrder
   * @duplicate
   * @secure
   */
  updateWorkOrder2 = (workOrderId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Approve a work order scope pre-approval.
   *
   * @tags Maintenance
   * @name ApproveWorkOrder
   * @summary Approve Work Order
   * @request POST:/api/maintenance/work-orders/{work_order_id}/approve
   * @secure
   */
  approveWorkOrder = (workOrderId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}/approve`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Reject a work order scope pre-approval.
   *
   * @tags Maintenance
   * @name RejectWorkOrder
   * @summary Reject Work Order
   * @request POST:/api/maintenance/work-orders/{work_order_id}/reject
   * @secure
   */
  rejectWorkOrder = (workOrderId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}/reject`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  getCockpit = (params = {}) =>
    this.http.request({
      path: `/api/maintenance/cockpit`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  getCockpitOperationsSummary = (params = {}) =>
    this.http.request({
      path: `/api/maintenance/cockpit/summary`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  compareRequestQuotes = (requestId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/quotes/compare`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  clarifyQuote = (quoteId, data = {}, params = {}) =>
    this.http.request({
      path: `/api/maintenance/quotes/${quoteId}/clarify`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Assign a work order to a vendor (transitions to ASSIGNED).
   *
   * @tags Maintenance
   * @name AssignWorkOrder
   * @summary Assign Work Order
   * @request POST:/api/maintenance/work-orders/{work_order_id}/assign
   * @secure
   */
  assignWorkOrder = (workOrderId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}/assign`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Technician / vendor departs for site (transitions to EN_ROUTE).
   *
   * @tags Maintenance
   * @name MarkWorkOrderEnRoute
   * @summary Mark Work Order En Route
   * @request POST:/api/maintenance/work-orders/{work_order_id}/en-route
   * @secure
   */
  markWorkOrderEnRoute = (workOrderId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}/en-route`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Technician / vendor arrives on site (transitions to ON_SITE).
   *
   * @tags Maintenance
   * @name MarkWorkOrderOnSite
   * @summary Mark Work Order On Site
   * @request POST:/api/maintenance/work-orders/{work_order_id}/on-site
   * @secure
   */
  markWorkOrderOnSite = (workOrderId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}/on-site`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Submit invoice and tax document details for a completed work order (transitions to INVOICED).
   *
   * @tags Maintenance
   * @name MarkWorkOrderInvoiced
   * @summary Mark Work Order Invoiced
   * @request POST:/api/maintenance/work-orders/{work_order_id}/invoice
   * @secure
   */
  markWorkOrderInvoiced = (workOrderId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}/invoice`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Vendor commences work order (transitions to IN_PROGRESS).
   *
   * @tags Maintenance
   * @name StartWorkOrder
   * @summary Start Work Order
   * @request POST:/api/maintenance/work-orders/{work_order_id}/start
   * @secure
   */
  startWorkOrder = (workOrderId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}/start`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Vendor finishes work and submits work order for review (transitions to REVIEW).
   *
   * @tags Maintenance
   * @name SubmitWorkOrderReview
   * @summary Submit Work Order Review
   * @request POST:/api/maintenance/work-orders/{work_order_id}/submit-review
   * @secure
   */
  submitWorkOrderReview = (workOrderId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}/submit-review`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Manager verifies and completes work order (transitions to COMPLETED).
   *
   * @tags Maintenance
   * @name CompleteWorkOrder
   * @summary Complete Work Order
   * @request POST:/api/maintenance/work-orders/{work_order_id}/complete
   * @secure
   */
  completeWorkOrder = (workOrderId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}/complete`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Cancel a work order (transitions to CANCELLED).
   *
   * @tags Maintenance
   * @name CancelWorkOrder
   * @summary Cancel Work Order
   * @request POST:/api/maintenance/work-orders/{work_order_id}/cancel
   * @secure
   */
  cancelWorkOrder = (workOrderId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}/cancel`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Send back a reviewed work order for vendor rework (transitions to IN_PROGRESS).
   *
   * @tags Maintenance
   * @name RequestWorkOrderRework
   * @summary Request Work Order Rework
   * @request POST:/api/maintenance/work-orders/{work_order_id}/rework
   * @secure
   */
  requestWorkOrderRework = (workOrderId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}/rework`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Dispatch a work order to an external marketplace contractor via time-limited guest link.
   *
   * @tags Maintenance
   * @name DispatchWorkOrder
   * @summary Dispatch Work Order
   * @request POST:/api/maintenance/work-orders/{work_order_id}/dispatch
   * @secure
   */
  dispatchWorkOrder = (workOrderId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}/dispatch`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Manually revoke/cancel a PENDING guest dispatch bridge link.
   *
   * @tags Maintenance
   * @name CancelWorkOrderDispatch
   * @summary Cancel Work Order Dispatch
   * @request POST:/api/maintenance/work-orders/{work_order_id}/dispatch/{dispatch_id}/cancel
   * @secure
   */
  cancelWorkOrderDispatch = (workOrderId, dispatchId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}/dispatch/${dispatchId}/cancel`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Attach a completed or invoiced work order's tax invoice and cost to a move-out deposit deduction.
   *
   * @tags Maintenance
   * @name AttachWorkOrderToMoveOut
   * @summary Attach Work Order To Move Out
   * @request POST:/api/maintenance/work-orders/{work_order_id}/attach-to-move-out
   * @secure
   */
  attachWorkOrderToMoveOut = (workOrderId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/work-orders/${workOrderId}/attach-to-move-out`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve aggregated operational KPIs for the Property Manager Maintenance Cockpit: open requests, SLA breaches, pending quotes, active work orders, and vendor rankings.
   *
   * @tags Maintenance
   * @name GetCockpitOperationsSummary
   * @summary Get Maintenance Operations Cockpit Summary
   * @request GET:/api/maintenance/cockpit/summary
   * @secure
   */
  getCockpitOperationsSummary = (params = {}) =>
    this.http.request({
      path: `/api/maintenance/cockpit/summary`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve consolidated daily roadmap stops, property geocodes, contact details, and financial metrics (pipeline, tax retention, unbilled work, and statement reminders) for an independent contractor.
   *
   * @tags Maintenance
   * @name GetVendorCockpit
   * @summary Get Vendor Cockpit Dashboard Data
   * @request GET:/api/maintenance/cockpit
   * @secure
   */
  getVendorCockpit = (query, params = {}) =>
    this.http.request({
      path: `/api/maintenance/cockpit`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List and search catalog part items.
   *
   * @tags Maintenance
   * @name ListParts
   * @summary List Parts
   * @request GET:/api/maintenance/parts-catalog
   * @secure
   */
  listParts = (query, params = {}) =>
    this.http.request({
      path: `/api/maintenance/parts-catalog`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new catalog SKU part item.
   *
   * @tags Maintenance
   * @name CreatePart
   * @summary Create Part
   * @request POST:/api/maintenance/parts-catalog
   * @secure
   */
  createPart = (data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/parts-catalog`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve details for a specific catalog SKU part item.
   *
   * @tags Maintenance
   * @name GetPart
   * @summary Get Part
   * @request GET:/api/maintenance/parts-catalog/{id}
   * @secure
   */
  getPart = (id, params = {}) =>
    this.http.request({
      path: `/api/maintenance/parts-catalog/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing catalog SKU part item.
   *
   * @tags Maintenance
   * @name UpdatePart
   * @summary Update Part
   * @request PATCH:/api/maintenance/parts-catalog/{id}
   * @secure
   */
  updatePart = (id, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/parts-catalog/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a catalog SKU part item (if never allocated to tickets).
   *
   * @tags Maintenance
   * @name DeletePart
   * @summary Delete Part
   * @request DELETE:/api/maintenance/parts-catalog/{id}
   * @secure
   */
  deletePart = (id, params = {}) =>
    this.http.request({
      path: `/api/maintenance/parts-catalog/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description List stock records across all warehouse / property locations for a part.
   *
   * @tags Maintenance
   * @name ListStocksForPart
   * @summary List Stocks For Part
   * @request GET:/api/maintenance/parts-catalog/{id}/stocks
   * @secure
   */
  listStocksForPart = (id, params = {}) =>
    this.http.request({
      path: `/api/maintenance/parts-catalog/${id}/stocks`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add or increment stock for a part at a warehouse location.
   *
   * @tags Maintenance
   * @name AddStockForPart
   * @summary Add Stock For Part
   * @request POST:/api/maintenance/parts-catalog/{id}/stocks
   * @secure
   */
  addStockForPart = (id, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/parts-catalog/${id}/stocks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update stock quantity or threshold.
   *
   * @tags Maintenance
   * @name UpdateStock
   * @summary Update Stock
   * @request PATCH:/api/maintenance/parts-catalog/stocks/{stock_id}
   * @secure
   */
  updateStock = (stockId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/parts-catalog/stocks/${stockId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all parts consumed on a maintenance request and the total parts spend. When viewed by a tenant, commercial pricing (unit_cost, total_cost, total_parts_cost) is redacted to None to prevent disclosure of contractor/inventory costs.
   *
   * @tags Maintenance
   * @name ListTicketParts
   * @summary List Ticket Parts
   * @request GET:/api/maintenance/requests/{id}/parts
   * @secure
   */
  listTicketParts = (id, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${id}/parts`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Log or allocate a part onto a maintenance request. Decrements warehouse inventory stock if stock_id is provided, and recalculates request.total_cost.
   *
   * @tags Maintenance
   * @name AddTicketPart
   * @summary Add Ticket Part
   * @request POST:/api/maintenance/requests/{id}/parts
   * @secure
   */
  addTicketPart = (id, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${id}/parts`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Remove a part from a maintenance request. Restores inventory stock if linked, and recalculates request.total_cost.
   *
   * @tags Maintenance
   * @name DeleteTicketPart
   * @summary Delete Ticket Part
   * @request DELETE:/api/maintenance/requests/{id}/parts/{part_id}
   * @secure
   */
  deleteTicketPart = (id, partId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${id}/parts/${partId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description List all manual field measurements recorded on a maintenance request.
   *
   * @tags Maintenance
   * @name ListFieldMeasurements
   * @summary List Field Measurements
   * @request GET:/api/maintenance/requests/{id}/measurements
   * @secure
   */
  listFieldMeasurements = (id, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${id}/measurements`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Record a manual field measurement (e.g. pressure, temperature, voltage) on a maintenance request.
   *
   * @tags Maintenance
   * @name CreateFieldMeasurement
   * @summary Create Field Measurement
   * @request POST:/api/maintenance/requests/{id}/measurements
   * @secure
   */
  createFieldMeasurement = (id, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${id}/measurements`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Fetch a specific field measurement by ID.
   *
   * @tags Maintenance
   * @name GetFieldMeasurement
   * @summary Get Field Measurement
   * @request GET:/api/maintenance/requests/{id}/measurements/{measurement_id}
   * @secure
   */
  getFieldMeasurement = (id, measurementId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${id}/measurements/${measurementId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing field measurement.
   *
   * @tags Maintenance
   * @name UpdateFieldMeasurement
   * @summary Update Field Measurement
   * @request PUT:/api/maintenance/requests/{id}/measurements/{measurement_id}
   * @secure
   */
  updateFieldMeasurement = (id, measurementId, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${id}/measurements/${measurementId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a field measurement from a maintenance request.
   *
   * @tags Maintenance
   * @name DeleteFieldMeasurement
   * @summary Delete Field Measurement
   * @request DELETE:/api/maintenance/requests/{id}/measurements/{measurement_id}
   * @secure
   */
  deleteFieldMeasurement = (id, measurementId, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${id}/measurements/${measurementId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Retrieve unified activity timeline feed for a maintenance request. Aggregates status changes, vendor dispatches, work order transitions, parts allocations, photo evidence, and threaded human discussions.
   *
   * @tags Maintenance
   * @name GetRequestTimeline
   * @summary Get Request Timeline
   * @request GET:/api/maintenance/requests/{request_id}/timeline
   * @secure
   */
  getRequestTimeline = (requestId, query, params = {}) =>
    this.http.request({
      path: `/api/maintenance/requests/${requestId}/timeline`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Allow an unauthenticated external marketplace contractor to inspect work order details.
   *
   * @tags Maintenance
   * @name GetPublicDispatch
   * @summary Public Guest Vendor Dispatch Inspection
   * @request GET:/api/maintenance/public/dispatch/{token}
   */
  getPublicDispatch = (token, params = {}) =>
    this.http.request({
      path: `/api/maintenance/public/dispatch/${token}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description External contractor accepts dispatch, transitioning work order to ASSIGNED.
   *
   * @tags Maintenance
   * @name AcceptPublicDispatch
   * @summary Public Guest Vendor Accept Dispatch
   * @request POST:/api/maintenance/public/dispatch/{token}/accept
   */
  acceptPublicDispatch = (token, params = {}) =>
    this.http.request({
      path: `/api/maintenance/public/dispatch/${token}/accept`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description External contractor declines dispatch.
   *
   * @tags Maintenance
   * @name DeclinePublicDispatch
   * @summary Public Guest Vendor Decline Dispatch
   * @request POST:/api/maintenance/public/dispatch/{token}/decline
   */
  declinePublicDispatch = (token, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/public/dispatch/${token}/decline`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description External contractor submits a cost quote directly from a guest dispatch link.
   *
   * @tags Maintenance
   * @name SubmitPublicDispatchQuote
   * @summary Public Guest Vendor Quote Submission
   * @request POST:/api/maintenance/public/dispatch/{token}/quote
   */
  submitPublicDispatchQuote = (token, data, params = {}) =>
    this.http.request({
      path: `/api/maintenance/public/dispatch/${token}/quote`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
